export default "__VITE_ASSET__CFZT$1Hv__"